// Checks if the relatedTarget of a focus / blur event (the element the focus is going to) is located inside
// the currentTarget (the element on which the handler was set).
const focusInCurrentTarget = ({
  relatedTarget,
  currentTarget
}) => {
  if (!relatedTarget) return false;
  let {
    parentNode: node
  } = relatedTarget;
  while (node) {
    if (node === currentTarget) return true;
    node = node.parentNode;
  }
  return false;
};
export default focusInCurrentTarget;
//# sourceMappingURL=focus-in-current-target.js.map